var Theme = Theme || {};

Theme.DocumentViewerPdf = (function ($) {
    let currentPage = 1;
    let totalPages = 0;    
    let multimediaData = null;    

    return {
        init: _initPdfViewer
    };
        
    function _initPdfViewer($epubViewer) {
        if($epubViewer.length) {
            return;
        }

        const $previousPageLink = $('.js-document-viewer-previouspage');
        const $nextPageLink = $('.js-document-viewer-nextpage');
        const $docContainer = $('.document');

        // Pagination controls
        $previousPageLink.on('click', handlePreviousPageClickEvent);
        $nextPageLink.on('click', handleNextPageClickEvent);
        $docContainer.on('scroll', debounce(enableDisablePaginationButtons, 250));

        loadPDF();
    }

    function handlePreviousPageClickEvent() {
        const $previousPageLink = $('.js-document-viewer-previouspage');
        currentPage = parseInt($('#pdfViewer').attr('data-pdf-current-page'));
        currentPage--;
        $('#pdfViewer').attr('data-pdf-current-page', currentPage);
        scrollToPagePdf(`#pdfPage${currentPage}`);
        $previousPageLink.toggleClass('disabled', currentPage <= 1);
    }

    function handleNextPageClickEvent() {
        let pdfPagesLoaded = parseInt($('#pdfViewer').attr('data-pages-loaded'));
        currentPage = parseInt($('#pdfViewer').attr('data-pdf-current-page'));
        if (currentPage < pdfPagesLoaded) {
            currentPage++;
            $('#pdfViewer').attr('data-pdf-current-page', currentPage);
            scrollToPagePdf(`#pdfPage${currentPage}`);
        }
        else {
            const pdfData = base64ToArrayBuffer(multimediaData);
            const pagesPerLoad = parseInt($('#pdfViewer').data('pages-per-load'));
            if (currentPage < totalPages) {
                currentPage++;
                pdfjsLib.getDocument({ data: pdfData }).promise.then(function (pdf) {
                    totalPages = pdf.numPages;

                    $('#pdfViewer').attr('data-pdf-total-pages', totalPages);
                    loadPageRange(pdf, currentPage);
                    $('#pdfViewer').attr('data-pages-loaded', currentPage + pagesPerLoad - 1);                            
                }).catch(function (error) {
                    console.error('Error loading PDF:', error);
                }).finally(function () {
                    SCM.Retry.policy()
                        .handleResult(function (result) { return !result; })
                        .waitAndRetry(5, 500)
                        .execute(function () {
                            return $(`#pdfPage${currentPage}`).length;
                        })
                        .then(function () {
                            scrollToPagePdf(`#pdfPage${currentPage}`);
                        })
                        .catch(function () {
                            console.error('Timed out waiting for the page to be ready.');
                        });
                    
                });
            }
        }    
    }

    function base64ToArrayBuffer(base64) {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    // Initialize the PDF
    function loadPDF() {
        const multimediaType = $('#pdfViewer').data('multimedia-type');
        const multimediaUrl = $('#pdfViewer').data('multimedia-url');
        SCM.Ajax.get('/DocumentViewer/GetMultimediaData', { multimediaType: multimediaType, multimediaUrl: multimediaUrl })
            .expectJson()
            .then(function (result) {
                multimediaData = result.Data;
                const pdfData = base64ToArrayBuffer(multimediaData);

                pdfjsLib.getDocument({ data: pdfData }).promise.then(function (pdf) {
                    totalPages = pdf.numPages;
                    $('#pdfViewer').attr('data-pdf-total-pages', totalPages);
                    loadPageRange(pdf, currentPage);                    
                }).catch(function (error) {
                    console.error('Error loading PDF:', error);
                });
            })
            .catch(function (error) {
                console.error('Error loading multimedia data:', error);
            });
        
    }

    async function loadPageRange(pdfDoc, startPage) {
        const pagesPerLoad = parseInt($('#pdfViewer').data('pages-per-load'));
        const endPage = Math.min(startPage + pagesPerLoad - 1, totalPages); 
        const $pdfViewer = $('#pdfViewer');
        const $previousPageLink = $('.js-document-viewer-previouspage');
        const $nextPageLink = $('.js-document-viewer-nextpage');

        for (let pageNum = startPage; pageNum <= endPage; pageNum++) {
            await renderPage(pageNum, $pdfViewer, pdfDoc);
        }

        $('#pdfViewer').attr('data-pdf-current-page', currentPage);
        $previousPageLink.toggleClass('disabled', currentPage === 1);
        $nextPageLink.toggleClass('disabled', currentPage === totalPages);

    }

    function renderPage(pageNumber, $pdfViewer, pdfDoc) {      
        return pdfDoc.getPage(pageNumber).then(function (page) {
            const scale = 1.5;  // Define a scale to control PDF size
            const viewport = page.getViewport({ scale: scale });

            // Create a canvas for each page
            const canvas = document.createElement('canvas');
            $(canvas).attr('id', `pdfPage${pageNumber}`);
            $(canvas).attr('data-pagenum', pageNumber);
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            $pdfViewer.append(canvas);

            const context = canvas.getContext('2d');

            // Render the PDF page into the canvas
            const renderContext = {
                canvasContext: context,
                viewport: viewport
            };

            return page.render(renderContext).promise;
        });
    }

    function enableDisablePaginationButtons() {
        const $previousPageLink = $('.js-document-viewer-previouspage');
        const $nextPageLink = $('.js-document-viewer-nextpage');
        let currentPage = getCurrentPdfPageNumber();
        $('#pdfViewer').attr('data-pdf-current-page', currentPage);

        $previousPageLink.toggleClass('disabled', currentPage === 1);
        $nextPageLink.toggleClass('disabled', currentPage === totalPages);
    }

    function scrollToPagePdf(scrollToElem) {
        const $docContainer = $('.document');
        let position = $(scrollToElem).offset().top - $docContainer.offset().top + $docContainer.scrollTop();
        $docContainer.scrollTop(position);
    }

    function getCurrentPdfPageNumber() {
        const $docContainer = $('.document');
        let docContainerTop = $docContainer.offset().top;
        let docContainerMiddle = Math.abs(docContainerTop + ($docContainer.height() / 2));
        let pages = $('canvas[id^="pdfPage"]');
        let currentPageNum = 0;
        let $currentPageElem;

        $.each(pages, function (i, elem) {
            let $pageElem = $(elem);
            let pageElemTop = $pageElem.offset().top;
            let pageElemBottom = $pageElem.position().top + $pageElem.outerHeight();
            if (isElementInViewOfPdfReader(pageElemTop, pageElemBottom, docContainerTop, docContainerMiddle)) {
                $currentPageElem = $(elem);
                return false;
            }
        });

        if ($currentPageElem) {
            currentPageNum = parseInt($currentPageElem.data('pagenum'));
        }

        return currentPageNum;
    }

    function isElementInViewOfPdfReader(pageElemTop, pageElemBottom, documentContainerTop, documentContainerMiddle) {
        return ((pageElemTop > documentContainerTop && pageElemTop < documentContainerMiddle) ||
            (pageElemBottom > documentContainerTop && pageElemBottom > documentContainerMiddle));
    }

})(jQuery);